import React, {
  FC, ReactNode, PropsWithChildren, HTMLProps
} from 'react';

import {
  Tooltip
} from 'src/shared/components';
import {
  useMediaQuery
} from 'src/shared/hooks';

import * as Style from './StatisticRow.styles';

interface StatisticTileProps extends HTMLProps<HTMLDivElement> {
  icon: ReactNode;
  amount?: number | null;
  growth?: number | null;
  withBorder?: boolean;
  applyMinWidth?: boolean;
  height?: number | string;
  amountLeader?: string;
}

export const StatisticTile: FC<StatisticTileProps> = ({
  icon,
  amount,
  growth,
  withBorder = false,
  applyMinWidth = true,
  height = 48,
  amountLeader,
  ...props
}) => {
  const isMobile = useMediaQuery(
    'md',
    'down'
  );

  return (
    <Style.TileContainer
      $withBorder={withBorder}
      $height={isMobile ? 32 : height}
      {...props}
    >
      {icon}

      <Style.TileContent>
        <div>
          {!!amountLeader && (
            <Tooltip
              variant="dark"
              opacity={1}
              disabled={isMobile}
              message={
                <Style.TooltipContainer>{amountLeader}</Style.TooltipContainer>
              }
            >
              <Style.AmountLeader>{amountLeader}</Style.AmountLeader>
            </Tooltip>
          )}

          <Style.AmountContainer $isMulti={!!amountLeader}>
            <Style.Amount $applyMinWidth={applyMinWidth && !amountLeader}>
              {typeof amount === 'number' ? `${amount}%` : '-'}
            </Style.Amount>

            {!!growth && (
              <Style.Growth $isGrowing={growth >= 0}>
                {`(${growth >= 0 ? '+' : ''}${growth}%)`}
              </Style.Growth>
            )}
          </Style.AmountContainer>
        </div>
      </Style.TileContent>
    </Style.TileContainer>
  );
};

interface StatisticRowProps extends PropsWithChildren {
  isTableView?: boolean;
}

export const StatisticRow: FC<StatisticRowProps> = ({
  children,
  isTableView = false,
}) => {
  return (
    <Style.RowContainer $withBackground={isTableView}>
      {children}
    </Style.RowContainer>
  );
};
